import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';
import axios from 'axios';
import './ScoreController.css';

const ScoreController = () => {
  const [marketsSuspended, setMarketsSuspended] = useState(false);
  const [isFreeHitMode, setIsFreeHitMode] = useState(false);

  const [isNoBallMode, setIsNoBallMode] = useState(false);

  const noBallOutcomes = [
  { label: 'NB + 0',        value: { runs: 0 }, color: 'default' },
  { label: 'NB + 1',        value: { runs: 1 }, color: 'default' },
  { label: 'NB + 2',        value: { runs: 2 }, color: 'default' },
  { label: 'NB + 3',        value: { runs: 3 }, color: 'default' },
  { label: 'NB + 4',        value: { runs: 4 }, color: 'boundary' },
  { label: 'NB + 6',        value: { runs: 6 }, color: 'boundary' },
  { label: 'NB + Run Out',  value: { runs: 0, isRunOut: true }, color: 'wicket' },
];

  const [freeHitOutcome, setFreeHitOutcome] = useState(null);
  const [eventId, setEventId] = useState('');
  const [socket, setSocket] = useState(null);
  const [matchData, setMatchData] = useState(null);
  const [autoPlayActive, setAutoPlayActive] = useState(false);
  const [matchStatus, setMatchStatus] = useState(null);
  const [scheduledBall, setScheduledBall] = useState(null);
  const [delaySeconds, setDelaySeconds] = useState(0);
  const [selectedOutcome, setSelectedOutcome] = useState(null);
  const [connectionStatus, setConnectionStatus] = useState('disconnected');
  const [showEditBallModal, setShowEditBallModal] = useState(false);
  const [showInjuryModal, setShowInjuryModal] = useState(false);
  const [injuryData, setInjuryData] = useState({ player: '', type: 'minor', team: 'A' });
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [timeoutTeam, setTimeoutTeam] = useState('');
  const [matchTimer, setMatchTimer] = useState({ elapsed: 0, remaining: 120 });
  const [inningBreakInfo, setInningBreakInfo] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [battingFirst, setBattingFirst] = useState('teamA');
  // New state for odds
  const [bookmakerOdds, setBookmakerOdds] = useState(null);
  const [sessionOdds, setSessionOdds] = useState([]);
  const [ballRunning, setBallRunning] = useState(false);

  // Manual Odds Control States
  const [selectedMarket, setSelectedMarket] = useState('match');
  const [activeSelection, setActiveSelection] = useState('teamA');
  const [activeBackLay, setActiveBackLay] = useState('back');
  const [manualBackOdds, setManualBackOdds] = useState('');
  const [manualLayOdds, setManualLayOdds] = useState('');
  const [calculatedOdds, setCalculatedOdds] = useState({ teamA: { back: 0, lay: 0 }, teamB: { back: 0, lay: 0 } });
  const [sessionMarkets, setSessionMarkets] = useState([]);
  const [selectedSessionOver, setSelectedSessionOver] = useState('');
  const [sessionYesOdds, setSessionYesOdds] = useState('');
  const [sessionNoOdds, setSessionNoOdds] = useState('');

  // Custom Session state - existing Over Session logic remains unchanged
  const [customSessionName, setCustomSessionName] = useState('');

  // Session presets
  const sessionPresets = [
    { value: '1', label: 'Over 1' }, { value: '2', label: 'Over 2' },
    { value: '3', label: 'Over 3' }, { value: '4', label: 'Over 4' },
    { value: '5', label: 'Over 5' }, { value: '6', label: 'Over 6' },
    { value: '7', label: 'Over 7' }, { value: '8', label: 'Over 8' },
    { value: '9', label: 'Over 9' }, { value: '10', label: 'Over 10' },
    { value: '11', label: 'Over 11' }, { value: '12', label: 'Over 12' },
    { value: '13', label: 'Over 13' }, { value: '14', label: 'Over 14' },
    { value: '15', label: 'Over 15' }, { value: '16', label: 'Over 16' },
    { value: '17', label: 'Over 17' }, { value: '18', label: 'Over 18' },
    { value: '19', label: 'Over 19' }, { value: '20', label: 'Over 20' }
  ];

  const ballOutcomes = [
    { label: '0 Run', value: { type: 'dot', runs: 0 }, color: 'default' },
    { label: '1 Run', value: { type: 'single', runs: 1 }, color: 'default' },
    { label: '2 Runs', value: { type: 'double', runs: 2 }, color: 'default' },
    { label: '3 Runs', value: { type: 'triple', runs: 3 }, color: 'default' },
    { label: '4 Runs', value: { type: 'four', runs: 4 }, color: 'boundary' },
    { label: '6 Runs', value: { type: 'six', runs: 6 }, color: 'boundary' },
    { label: 'Wicket', value: { type: 'wicket', runs: 0, isWicket: true }, color: 'wicket' },
    { label: 'Wide', value: { type: 'wide', runs: 1, isExtra: true, extraType: 'wide' }, color: 'extra' },
    { label: 'Wide + 4', value: { type: 'wide', runs: 5, isExtra: true, extraType: 'wide', extraRuns: 4 }, color: 'extra' },
    { label: 'No Ball', value: { type: 'no_ball', runs: 1, isExtra: true, extraType: 'no_ball' }, color: 'extra' },
    { label: 'Bye', value: { type: 'bye', runs: 1, isExtra: true, extraType: 'bye' }, color: 'extra' },
    { label: 'Leg Bye', value: { type: 'leg_bye', runs: 1, isExtra: true, extraType: 'leg_bye' }, color: 'extra' },
    { label: 'Leg Bye + 4', value: { type: 'leg_bye', runs: 5, isExtra: true, extraType: 'leg_bye', extraRuns: 4 }, color: 'extra' }
  ];

  const freeHitOutcomes = [
    { label: 'Free Hit - 0 Run', value: { type: 'dot', runs: 0 }, color: 'default' },
    { label: 'Free Hit - 1 Run', value: { type: 'single', runs: 1 }, color: 'default' },
    { label: 'Free Hit - 2 Runs', value: { type: 'double', runs: 2 }, color: 'default' },
    { label: 'Free Hit - 3 Runs', value: { type: 'triple', runs: 3 }, color: 'default' },
    { label: 'Free Hit - 4 Runs', value: { type: 'four', runs: 4 }, color: 'boundary' },
    { label: 'Free Hit - 6 Runs', value: { type: 'six', runs: 6 }, color: 'boundary' },
    { label: 'Free Hit - Run Out', value: { type: 'wicket', runs: 0, isWicket: true, wicketType: 'run_out' }, color: 'wicket' }
  ];

  // Auto calculate odds function
const autoCalculateOdds = () => {
  const backOdds = parseFloat(manualBackOdds);
  const layOdds = parseFloat(manualLayOdds);

  if (isNaN(backOdds) || isNaN(layOdds)) return;

  const CONSTANT = 10000;
  const MAX_ODDS = 9999;

  const safeDivide = (num, denom) => {
    if (!denom || denom === 0) return 0;
    return Math.min(Math.round(num / denom), MAX_ODDS);
  };

  let newTeamAOdds, newTeamBOdds;

  if (activeSelection === 'teamA') {
    newTeamAOdds = { back: backOdds, lay: layOdds };

    const teamAHasZero = (backOdds === 0 || layOdds === 0);

    newTeamBOdds = teamAHasZero
      ? { back: 0, lay: 0 }   // both will render as "-"
      : {
          back: safeDivide(CONSTANT, layOdds),
          lay:  safeDivide(CONSTANT, backOdds)
        };
  } else {
    newTeamBOdds = { back: backOdds, lay: layOdds };

    const teamBHasZero = (backOdds === 0 || layOdds === 0);

    newTeamAOdds = teamBHasZero
      ? { back: 0, lay: 0 }
      : {
          back: safeDivide(CONSTANT, layOdds),
          lay:  safeDivide(CONSTANT, backOdds)
        };
  }

  setCalculatedOdds({ teamA: newTeamAOdds, teamB: newTeamBOdds });
};

  useEffect(() => {
    if (manualBackOdds !== '' && manualLayOdds !== '') {
      autoCalculateOdds();
    }
  }, [manualBackOdds, manualLayOdds, activeSelection, activeBackLay]);

  // Load sessionMarkets from localStorage when eventId changes
useEffect(() => {
  if (!eventId) return;
  const stored = localStorage.getItem(`sessionMarkets_${eventId}`);
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      setSessionMarkets(parsed);
    } catch (e) {
      console.error('Failed to parse stored session markets:', e);
    }
  }
}, [eventId]);

// Save sessionMarkets to localStorage whenever they change
useEffect(() => {
  if (eventId) {
    localStorage.setItem(`sessionMarkets_${eventId}`, JSON.stringify(sessionMarkets));
  }
}, [sessionMarkets, eventId]);

const addNotification = (message, type = 'info') => {
  const id = Date.now();
  setNotifications(prev => [...prev, { id, message, type }]);
  // 2 seconds timeout - 2000ms
  setTimeout(() => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  }, 2000);
};

  const updateBookmakerOdds = () => {
    autoCalculateOdds();
    addNotification('Odds calculated', 'info');
  };

  const addSessionMarket = () => {
    if (!selectedSessionOver || !sessionYesOdds || !sessionNoOdds) {
      addNotification('Please select over and enter both YES and NO odds', 'error');
      return;
    }
    
    const yesOdds = parseFloat(sessionYesOdds);
    const noOdds = parseFloat(sessionNoOdds);
    
    if (isNaN(yesOdds) || isNaN(noOdds)) {
      addNotification('Please enter valid odds numbers', 'error');
      return;
    }
    
    const yesBackOdds = yesOdds;
    const yesLayOdds = yesOdds + 1;
    const noBackOdds = noOdds;
    const noLayOdds = noOdds + 1;
    
    const marketId = Date.now();
    const newMarket = {
      id: marketId,
      over: selectedSessionOver,
      odds: { yes: { back: yesBackOdds, lay: yesLayOdds }, no: { back: noBackOdds, lay: noLayOdds } },
      yesOdds: yesOdds,
      noOdds: noOdds,
      status: 'ACTIVE'
    };
    
    setSessionMarkets([...sessionMarkets, newMarket]);
    addNotification(`Added ${selectedSessionOver} - YES: ${yesOdds} | NO: ${noOdds}`, 'success');
    setSelectedSessionOver('');
    setSessionYesOdds('');
    setSessionNoOdds('');
  };

  // Add a custom session without changing the existing Over-based session logic
  const addCustomSessionMarket = () => {
    const runnerName = customSessionName.trim();

    if (!runnerName || !sessionYesOdds || !sessionNoOdds) {
      addNotification(
        'Please enter custom runner name and both YES and NO odds',
        'error'
      );
      return;
    }

    const yesOdds = parseFloat(sessionYesOdds);
    const noOdds = parseFloat(sessionNoOdds);

    if (isNaN(yesOdds) || isNaN(noOdds)) {
      addNotification('Please enter valid odds numbers', 'error');
      return;
    }

    const marketId = Date.now() + Math.floor(Math.random() * 1000);

    const newMarket = {
      id: marketId,
      over: `CUSTOM_${marketId}#`,
      runnerName,
      isCustom: true,
      odds: {
        yes: {
          back: yesOdds,
          lay: yesOdds + 1
        },
        no: {
          back: noOdds,
          lay: noOdds + 1
        }
      },
      yesOdds,
      noOdds,
      status: 'ACTIVE'
    };

    setSessionMarkets(prev => [...prev, newMarket]);

    addNotification(
      `Added Custom Session: ${runnerName}`,
      'success'
    );

    setCustomSessionName('');
    setSessionYesOdds('');
    setSessionNoOdds('');
  };

  const removeSessionMarket = (marketId) => {
    setSessionMarkets(sessionMarkets.filter(m => m.id !== marketId));
    addNotification('Session market removed', 'info');
  };

  const updateSessionOddsManually = (marketId, type, value) => {
    const newValue = parseFloat(value);
    if (isNaN(newValue)) return;
    
    setSessionMarkets(sessionMarkets.map(market => {
      if (market.id === marketId) {
        if (type === 'yes') {
          const yesBackOdds = newValue;
          const yesLayOdds = newValue + 1;
          return { ...market, odds: { ...market.odds, yes: { back: yesBackOdds, lay: yesLayOdds } }, yesOdds: newValue };
        } else {
          const noBackOdds = newValue;
          const noLayOdds = newValue + 1;
          return { ...market, odds: { ...market.odds, no: { back: noBackOdds, lay: noLayOdds } }, noOdds: newValue };
        }
      }
      return market;
    }));
  };

  const toggleSessionStatus = (marketId) => {
    setSessionMarkets(sessionMarkets.map(market => {
      if (market.id === marketId) {
        return { ...market, status: market.status === 'ACTIVE' ? 'SUSPENDED' : 'ACTIVE' };
      }
      return market;
    }));
  };

const applyBookmakerOdds = async () => {
  if (manualBackOdds === '' || manualLayOdds === '') {
    addNotification('Please enter both back and lay odds first', 'error');
    return;
  }
    
    try {
const response = await axios.put(
  `/api/matches/${eventId}/manual-odds`,
  {
    bookmakerOdds: {
      teamA: {
        back: calculatedOdds.teamA.back,
        lay: calculatedOdds.teamA.lay
      },
      teamB: {
        back: calculatedOdds.teamB.back,
        lay: calculatedOdds.teamB.lay
      }
    }
  }
);
      
      if (response.data.success) {
        addNotification('✅ Bookmaker odds applied successfully', 'success');
        setTimeout(() => refreshStatus(), 500);
      }
    } catch (error) {
      console.error('Error applying odds:', error);
      addNotification(`❌ Error applying odds: ${error.response?.data?.error || error.message}`, 'error');
    }
  };

  const applySessionOdds = async () => {
    if (sessionMarkets.length === 0) {
      addNotification('No session markets to apply', 'error');
      return;
    }
    
    const sessionOddsData = {};
    sessionMarkets.forEach(market => {
      const marketKey = market.isCustom
        ? `custom_${market.id}`
        : market.over;

      sessionOddsData[marketKey] = {
        back: market.odds.yes.lay,
        lay: market.odds.yes.back,
        status: market.status,
        active: market.status === 'SUSPENDED' ? 'SUSPENDED' : 'ACTIVE',
        ...(market.isCustom
          ? {
              // Backend uses this exact value as RunnerName.
              runnerName: market.runnerName,
              remark: `${market.runnerName} - YES: ${market.yesOdds} | NO: ${market.noOdds}`
            }
          : {
              remark: `Over ${market.over} - YES: ${market.yesOdds} | NO: ${market.noOdds}`
            })
      };
    });
    
    try {
const response = await axios.put(
  `/api/matches/${eventId}/manual-odds`,
  {
    sessionOdds: sessionOddsData
  }
);
      
      if (response.data.success) {
        addNotification('✅ Session odds applied successfully', 'success');
        setTimeout(() => refreshStatus(), 500);
      }
    } catch (error) {
      console.error('Error applying session odds:', error);
      addNotification(`❌ Error applying session odds: ${error.response?.data?.error || error.message}`, 'error');
    }
  };

  useEffect(() => {
    if (!eventId) return;

    const newSocket = io({
      transports: ['websocket', 'polling']
    });
    setSocket(newSocket);
    setConnectionStatus('connecting');

    newSocket.on('connect', () => {
      console.log('Socket connected');
      setConnectionStatus('connected');
      addNotification('Connected to server', 'success');
      newSocket.emit('join_match', eventId);
      newSocket.emit('get_match_status', eventId);
      newSocket.emit('getOddData', { eventId });
      newSocket.emit('liveScore', { eventId });
    });

    newSocket.on('connect_error', (error) => {
      console.error('Connection error:', error);
      setConnectionStatus('error');
      addNotification('Connection error', 'error');
    });

    newSocket.on('inning_break_start', (data) => {
      console.log('=== INNING BREAK START RECEIVED ===', data);
      setInningBreakInfo(data);
      addNotification(`🔄 ${data.message}`, 'info');
    });

    newSocket.on('match_data', (data) => setMatchData(data));
    newSocket.on('force_start_result', (data) => {
      if (data.success) {
        addNotification(`✅ ${data.message}`, 'success');
        setInningBreakInfo(null);
      } else {
        addNotification(`❌ ${data.message}`, 'error');
      }
    });

    newSocket.on('liveScore', (data) => {
      if (data && data.data) {
        setMatchData(prev => ({ ...prev, ...data.data }));
      }
    });

    newSocket.on('suspend_all_result', (data) => {
  if (data.success) {
    addNotification(`✅ ${data.message}`, 'success');
    setMarketsSuspended(data.suspended);
    refreshStatus();
  } else {
    addNotification(`❌ ${data.message}`, 'error');
  }
});

    newSocket.on('liveScore2', (data) => {
      if (data && data.data && data.data.data) {
        setMatchData(prev => ({ ...prev, ...data.data.data }));
      }
    });

    newSocket.on('eventGetLiveEventsFancyData', (data) => {
      console.log('Odds update received:', data);
      if (data.body?.cricket?.[0]) setBookmakerOdds(data.body.cricket[0]);
      if (data.body?.session?.[0]?.value?.session) setSessionOdds(data.body.session[0].value.session);
    });
    
    newSocket.on('match_start_result', (data) => {
      if (data.success) {
        addNotification(`✅ ${data.message}`, 'success');
        refreshStatus();
      } else {
        addNotification(`❌ ${data.message}`, 'error');
      }
    });

    newSocket.on('match_started', (data) => {
      addNotification(`🏏 ${data.message}`, 'success');
      refreshStatus();
    });

    newSocket.on('ball_update', (data) => {
      console.log('Ball update:', data);
      setBallRunning(true);
      setTimeout(() => setBallRunning(false), 3000);
      
      const outcome = data.outcome;
      let message = '';
      if (outcome.isWicket) {
        message = `🎯 WICKET! ${outcome.wicketType || 'Bowled'}`;
        addNotification(message, 'wicket');
      } else if (outcome.isExtra) {
        message = `📢 ${outcome.extraType.toUpperCase()}! +${outcome.runs} run${outcome.runs > 1 ? 's' : ''}`;
        addNotification(message, 'extra');
      } else {
        message = `🏏 ${outcome.runs} ${outcome.runs === 1 ? 'run' : 'runs'}`;
        if (outcome.runs === 4 || outcome.runs === 6) {
          addNotification(message, 'boundary');
        } else {
          addNotification(message, 'info');
        }
      }
    });

    // Edit Last Ball result handler
    newSocket.on('edit_last_ball_result', (data) => {
      if (data.success) {
        addNotification(`✅ ${data.message}`, 'success');
        refreshStatus();
      } else {
        addNotification(`❌ Failed to edit last ball: ${data.message}`, 'error');
      }
    });

    newSocket.on('last_ball_edited', (data) => {
      addNotification(`✏️ Last ball edited to ${data.newOutcome.type}`, 'info');
      refreshStatus();
    });

    newSocket.on('over_break', (data) => addNotification(`⏸️ ${data.message}`, 'warning'));
    newSocket.on('inning_break_end', (data) => {
      setInningBreakInfo(null);
      addNotification(`▶️ ${data.message}`, 'success');
    });
    newSocket.on('second_innings_start', (data) => addNotification(`🔄 ${data.message}`, 'success'));
    newSocket.on('strategic_timeout', (data) => {
      addNotification(`⏸️ ${data.message}`, 'warning');
      setBallRunning(true);
      setTimeout(() => setBallRunning(false), 3000);
    });
    newSocket.on('strategic_timeout_end', (data) => addNotification(`▶️ ${data.message}`, 'success'));
    newSocket.on('timeout_available', (data) => addNotification(`💡 ${data.message}`, 'info'));
    newSocket.on('player_injury', (data) => addNotification(`🏥 ${data.message}`, 'error'));
    newSocket.on('match_end', (data) => {
      addNotification(`🏆 ${data.message}`, 'success');
      setAutoPlayActive(false);
    });
    newSocket.on('match_complete', (data) => {
      addNotification(`🏆 ${data.message}`, 'success');
      setAutoPlayActive(false);
    });
    newSocket.on('match_time_update', (data) => setMatchTimer(data));
    newSocket.on('auto_play_status', (data) => setAutoPlayActive(data.success));
    newSocket.on('manual_ball_scheduled', (data) => {
      setScheduledBall(data);
      addNotification(`⏰ ${data.message}`, 'info');
    });
    newSocket.on('manual_ball_confirmed', (data) => {
      setScheduledBall(null);
      addNotification(`✅ Ball executed`, 'success');
    });
    newSocket.on('match_status', (data) => setMatchStatus(data));
    newSocket.on('error', (data) => addNotification(`❌ ${data.message}`, 'error'));
    newSocket.on('disconnect', () => {
      console.log('Socket disconnected');
      setConnectionStatus('disconnected');
      addNotification('Disconnected from server', 'error');
    });

    return () => { if (newSocket) newSocket.disconnect(); };
  }, [eventId]);

const handleManualBall = (outcome) => {
  if (socket && eventId && matchData?.status === 'live') {

    // Free hit delivery (2nd step)
    if (isFreeHitMode && freeHitOutcome) {
      socket.emit('manual_ball_update', {
        eventId,
        ballOutcome: { ...freeHitOutcome, isFreeHit: true }
      });
      addNotification(`🎯 Free Hit: ${freeHitOutcome.type}`, 'info');
      setIsFreeHitMode(false);
      setFreeHitOutcome(null);
      return;
    }

    // No ball → open no ball panel (1st step)
    if (outcome.type === 'no_ball') {
      setIsNoBallMode(true);
      addNotification('📢 NO BALL! Select runs scored on the no ball', 'warning');
      return;
    }

    // Normal deliveries
    const delay = delaySeconds > 0 ? delaySeconds : 0;
    if (delay > 0) {
      socket.emit('schedule_manual_ball', { eventId, ballOutcome: outcome, delaySeconds: delay });
      addNotification(`⏰ Scheduling ${outcome.type} in ${delay} seconds`, 'info');
    } else {
      socket.emit('manual_ball_update', { eventId, ballOutcome: outcome });
      addNotification(`🎯 Playing ${outcome.type}`, 'info');
    }
  } else {
    addNotification(`Cannot play ball - Match status: ${matchData?.status || 'unknown'}`, 'error');
  }
};

const handleNoBallOutcome = (noBallResult) => {
  if (!socket || !eventId) return;

  socket.emit('manual_ball_update', {
    eventId,
    ballOutcome: {
      type: 'no_ball',
      runs: 1,                     // penalty run
      isExtra: true,
      extraType: 'no_ball',
      batRuns: noBallResult.runs,  // runs scored off bat on the no ball
      isRunOut: noBallResult.isRunOut || false
    }
  });

  setIsNoBallMode(false);
  setIsFreeHitMode(true);
  addNotification('No ball recorded. Now select the free hit outcome', 'info');
};
  // Edit Last Ball handler - Opens modal to change previous ball outcome
  const handleEditLastBall = (newOutcome) => {
    if (socket && eventId) {
      socket.emit('edit_last_ball', { eventId, newOutcome });
      setShowEditBallModal(false);
      addNotification(`✏️ Editing last ball to ${newOutcome.type}...`, 'info');
    }
  };

  const handleAutoPlay = () => {
    if (autoPlayActive) {
      socket.emit('stop_auto_play', eventId);
      setAutoPlayActive(false);
      addNotification('Auto play stopped', 'info');
    } else {
      socket.emit('start_auto_play', eventId);
      addNotification('Auto play started', 'success');
    }
  };

  const handleStrategicTimeout = () => {
    if (socket && eventId && timeoutTeam) {
      socket.emit('strategic_timeout', { eventId, teamName: timeoutTeam });
      setShowTimeoutModal(false);
      setTimeoutTeam('');
      addNotification(`Strategic timeout taken by ${timeoutTeam}`, 'info');
    } else {
      addNotification('Please select a team', 'error');
    }
  };

  const handlePlayerInjury = () => {
    if (socket && eventId && injuryData.player) {
      socket.emit('player_injury', {
        eventId,
        playerName: injuryData.player,
        injuryType: injuryData.type,
        team: injuryData.team
      });
      setShowInjuryModal(false);
      setInjuryData({ player: '', type: 'minor', team: 'A' });
      addNotification(`Injury recorded for ${injuryData.player}`, 'warning');
    } else {
      addNotification('Please enter player name', 'error');
    }
  };

  const refreshStatus = () => {
    if (socket && eventId) {
      socket.emit('get_match_status', eventId);
      socket.emit('getOddData', { eventId });
      addNotification('Refreshing match status and odds', 'info');
    }
  };

const suspendAllMarkets = () => {
  if (!socket || !eventId) return;
  socket.emit('suspend_all_markets', { eventId });
  addNotification('Suspending all markets...', 'info');
};


  
  const parseScore = (scoreString) => {
    if (!scoreString) return { runs: 0, wickets: 0, overs: 0, balls: 0 };
    const match = scoreString.match(/(\d+)-(\d+)\s*\((\d+)\.(\d+)\)/);
    if (match) {
      return {
        runs: parseInt(match[1]),
        wickets: parseInt(match[2]),
        overs: parseInt(match[3]),
        balls: parseInt(match[4])
      };
    }
    return { runs: 0, wickets: 0, overs: 0, balls: 0 };
  };

  const connectionStatusText = {
    connected: '✅ Connected',
    connecting: '🟡 Connecting...',
    disconnected: '🔴 Disconnected',
    error: '❌ Connection Error'
  };

  const getWicketsRemaining = () => {
    if (!matchData) return 10;
    const currentWickets = matchData.activenation1 === "1" ? 
      parseScore(matchData.score1).wickets : parseScore(matchData.score2).wickets;
    return 10 - currentWickets;
  };

  const getStatusText = (gameStatus, active) => {
    if (ballRunning) return "Ball Running";
    if (gameStatus === "SUSPENDED" || active === "SUSPENDED") return "SUSPENDED";
    return "ACTIVE";
  };

  const getStatusClass = (gameStatus, active) => {
    if (ballRunning) return "status-ball-running";
    if (gameStatus === "SUSPENDED" || active === "SUSPENDED") return "status-suspended";
    return "status-active";
  };

  if (!eventId) {
    return (
      <div className="score-controller">
        <div className="controller-header">
          <h2>🏏 Advanced Cricket Score Controller</h2>
          <p className="subtitle">Complete Match Control with Edit Last Ball, Injuries, Timeouts & More</p>
          <div className="match-selector">
            <input type="text" placeholder="Enter Market/Event ID" value={eventId} onChange={(e) => setEventId(e.target.value)} />
            <p className="hint">Enter the Market ID to control the match</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="score-controller">
      {/* Notifications */}
     <div className="notifications-container">
  {notifications.map(notif => (
    <div key={notif.id} className={`notification ${notif.type}`}>
      {notif.message}
    </div>
  ))}
</div>

      <div className="controller-header">
        <h2>🏏 Advanced Cricket Score Controller</h2>
        <div className="match-info-header">
          <div className="match-id">Match ID: {eventId}</div>
          <div className={`connection-status ${connectionStatus}`}>{connectionStatusText[connectionStatus]}</div>
          <button onClick={refreshStatus} className="refresh-btn">🔄 Refresh</button>
        </div>
      </div>

      {matchData ? (
        <div className="match-info">
          {/* Compact Sticky Header */}
          <div className="compact-sticky-header">
            {/* LEFT SECTION */}
            <div className="compact-left-section">
              <div className="compact-match-title">{matchData.spnnation1 || matchData.teamA} vs {matchData.spnnation2 || matchData.teamB}</div>
              <div className="compact-score-line">
                <div className="compact-team-score">
                  <span className="compact-team-short">{matchData.spnnation1 || matchData.teamA}</span>
                  <span className="compact-score">{parseScore(matchData.score1).runs}/{parseScore(matchData.score1).wickets}</span>
                  <span className="compact-over">({parseScore(matchData.score1).overs}.{parseScore(matchData.score1).balls})</span>
                  <span className="compact-rr">RR {matchData.spnrunrate1 || '0.00'}</span>
                </div>
                <div className="compact-vs">|</div>
                <div className="compact-team-score">
                  <span className="compact-team-short">{matchData.spnnation2 || matchData.teamB}</span>
                  <span className="compact-score">{parseScore(matchData.score2).runs}/{parseScore(matchData.score2).wickets}</span>
                  <span className="compact-over">({parseScore(matchData.score2).overs}.{parseScore(matchData.score2).balls})</span>
                  <span className="compact-rr">RR {matchData.spnrunrate2 || '0.00'}</span>
                </div>
              </div>
              {matchData.spnmessage && <div className="compact-match-message">{matchData.spnmessage}</div>}
            </div>

            {/* CENTER SECTION */}
            <div className="compact-center-section">
              <div className="compact-balls-row">
                {matchData.balls?.map((ball, index) => (
                  <span key={index} className={`compact-ball ${ball === 'W' ? 'compact-ball-wicket' : ''} ${ball === '4' || ball === '6' ? 'compact-ball-boundary' : ''} ${ball === 'WD' || ball === 'NB' || ball?.startsWith('B') || ball?.startsWith('LB') ? 'compact-ball-extra' : ''}`}>
                    {ball}
                  </span>
                ))}
              </div>
            </div>

            {/* RIGHT SECTION */}
            {bookmakerOdds && bookmakerOdds.bookmaker && (
              <div className="compact-right-section">
                {bookmakerOdds.bookmaker.map((runner, idx) => (
                  <div key={idx} className="compact-odds-runner">
                    <div className="compact-runner-name">{runner.name}</div>
                    <div className="compact-odds-line">
                      <span className="compact-back-odd">{runner.back?.[0]?.price > 0 ? runner.back[0].price.toFixed(1) : '--'}</span>
                      <span className="compact-lay-odd">{runner.lay?.[0]?.price > 0 ? runner.lay[0].price.toFixed(1) : '--'}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

  <div className="suspend-all-container">
  <button
    className="suspend-all-btn active"
    onClick={suspendAllMarkets}
    disabled={!matchData || (matchData.status !== 'live' && matchData.status !== 'completed')}
  >
    🔒 SUSPEND ALL MARKETS
  </button>
</div>

          {/* SPLIT ODDS PANEL */}
          <div className="split-odds-panel">
            {/* LEFT : MATCH ODDS */}
            <div className="split-match-section">
              <div className="split-section-title">🎲 MATCH ODDS</div>
              <div className="split-control-row">
                <select value={activeSelection} onChange={(e) => setActiveSelection(e.target.value)} className="split-select">
                  <option value="teamA">{matchData?.teamA || 'Team A'}</option>
                  <option value="teamB">{matchData?.teamB || 'Team B'}</option>
                </select>
                <select value={activeBackLay} onChange={(e) => setActiveBackLay(e.target.value)} className="split-select">
                  <option value="back">BACK</option>
                  <option value="lay">LAY</option>
                </select>
              </div>
              <div className="split-input-row">
          <input type="number" step="1" min="0" max="999" placeholder="BACK" value={manualBackOdds} onChange={(e) => setManualBackOdds(e.target.value)} className="split-input" />
          <input type="number" step="1" min="1" max="999" placeholder="LAY" value={manualLayOdds} onChange={(e) => setManualLayOdds(e.target.value)} className="split-input" />
              </div>
{manualBackOdds !== '' && manualLayOdds !== '' && (
  <div className="split-calculated-box">
                  <div className="split-team-row"><span className="split-team-name">{matchData?.teamA || 'Team A'}</span><span className="split-back-box">B {calculatedOdds.teamA.back}</span><span className="split-lay-box">L {calculatedOdds.teamA.lay}</span></div>
                  <div className="split-team-row"><span className="split-team-name">{matchData?.teamB || 'Team B'}</span><span className="split-back-box">B {calculatedOdds.teamB.back}</span><span className="split-lay-box">L {calculatedOdds.teamB.lay}</span></div>
                  <button className="split-btn split-apply-btn" onClick={applyBookmakerOdds}>APPLY MATCH ODDS</button>
                </div>
              )}
            </div>

            {/* RIGHT : SESSION */}
            <div className="split-session-section">
              <div className="split-section-title">📊 SESSION ODDS</div>
              <div className="split-session-create">
                <select value={selectedSessionOver} onChange={(e) => setSelectedSessionOver(e.target.value)} className="split-select">
                  <option value="">OVER</option>
                  {sessionPresets.map((preset) => (<option key={preset.value} value={preset.value}>{preset.label}</option>))}
                </select>
                <input type="number" step="1" min="1" placeholder="No" value={sessionYesOdds} onChange={(e) => setSessionYesOdds(e.target.value)} className="split-input" />
                <input type="number" step="1" min="1" placeholder="Yes" value={sessionNoOdds} onChange={(e) => setSessionNoOdds(e.target.value)} className="split-input" />
                <button className="split-btn split-add-btn" onClick={addSessionMarket}>ADD</button>
              </div>

              {/* CUSTOM SESSION - additional option; existing Over Session remains unchanged */}
              <div className="split-session-create custom-session-create">
                <input
                  type="text"
                  placeholder="Custom Runner Name"
                  value={customSessionName}
                  onChange={(e) => setCustomSessionName(e.target.value)}
                  className="split-input custom-session-name-input"
                />
                <input
                  type="number"
                  step="1"
                  min="1"
                  placeholder="No"
                  value={sessionYesOdds}
                  onChange={(e) => setSessionYesOdds(e.target.value)}
                  className="split-input"
                />
                <input
                  type="number"
                  step="1"
                  min="1"
                  placeholder="Yes"
                  value={sessionNoOdds}
                  onChange={(e) => setSessionNoOdds(e.target.value)}
                  className="split-input"
                />
                <button className="split-btn split-add-btn" onClick={addCustomSessionMarket}>
                  ADD CUSTOM
                </button>
              </div>
              {sessionMarkets.length > 0 && (
                <div className="split-session-list">
                  {sessionMarkets.map((market) => (
                    <div key={market.id} className="split-session-card">
                      <span className="split-over-box">
                        {market.isCustom ? market.runnerName : `O${market.over}`}
                      </span>
                      
                      <input
                        type="number"
                        value={market.yesOdds}
                        onChange={(e) => updateSessionOddsManually(market.id, 'yes', e.target.value)}
                        className="split-mini-input yes-input"
                      />
                      <button className="split-btn split-status-btn" onClick={() => toggleSessionStatus(market.id)}>{market.status === 'ACTIVE' ? 'ON' : 'OFF'}</button>
                      <button className="split-remove-btn" onClick={() => removeSessionMarket(market.id)}>×</button>
                    </div>
                  ))}
                  <button className="split-btn split-apply-btn" onClick={applySessionOdds}>APPLY SESSION</button>
                </div>
              )}
            </div>
          </div>

          {/* ULTRA COMPACT BALL CONTROLS */}
          <div className="ultra-ball-panel">
            <div className="ultra-ball-topbar">
              <div className="ultra-delay-box">
                <span className="ultra-label">⏰ DELAY</span>
                <input type="number" min="0" max="60" value={delaySeconds} onChange={(e) => setDelaySeconds(parseInt(e.target.value) || 0)} className="ultra-delay-input" />
                <button className="ultra-mini-btn ultra-auto-delay-btn" onClick={() => setDelaySeconds(20)}>AUTO 20s</button>
              </div>
              <div className="ultra-auto-box">
                <button onClick={handleAutoPlay} className={`ultra-auto-btn ${autoPlayActive ? 'active' : ''}`} disabled={matchData.status !== 'live'}>
                  {autoPlayActive ? '⏸ STOP AUTO' : '▶ AUTO'}
                </button>
                {delaySeconds > 0 && <span className="ultra-delay-note">{delaySeconds}s</span>}
              </div>
            </div>
            <div className="ultra-ball-buttons-wrap">
              <div className="ultra-ball-title">🎯 MANUAL BALLS</div>
              <div className="ultra-ball-grid">
                {ballOutcomes.map((outcome, index) => (
                  <button key={index} onClick={() => handleManualBall(outcome.value)} className={`ultra-ball-btn ${outcome.color}`} disabled={matchData.status !== 'live'}>
                    {outcome.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {isNoBallMode && (
            <div className="mini-free-hit-panel">
              <div className="mini-free-hit-header">
                <span className="mini-free-hit-title">📢 NO BALL — Select Runs</span>
                <button
                  className="mini-cancel-free-hit-btn"
                  onClick={() => {
                    setIsNoBallMode(false);
                    addNotification('No ball cancelled', 'info');
                  }}
                >✕</button>
              </div>
              <div className="mini-free-hit-buttons">
                {noBallOutcomes.map((outcome, index) => (
                  <button
                    key={index}
                    onClick={() => handleNoBallOutcome(outcome.value)}
                    className={`mini-free-hit-btn ${outcome.color}`}
                  >
                    {outcome.label}
                  </button>
                ))}
              </div>
            </div>
          )}
          {/* FREE HIT PANEL */}
          {isFreeHitMode && (
            <div className="mini-free-hit-panel">
              <div className="mini-free-hit-header">
                <span className="mini-free-hit-title">🎲 FREE HIT</span>
                <button className="mini-cancel-free-hit-btn" onClick={() => { setIsFreeHitMode(false); addNotification('Free hit cancelled', 'info'); }}>✕</button>
              </div>
              <div className="mini-free-hit-buttons">
                {freeHitOutcomes.map((outcome, index) => (
                  <button key={index} onClick={() => setFreeHitOutcome(outcome.value)} className={`mini-free-hit-btn ${outcome.color}`}>
                    {outcome.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* EDIT LAST BALL BUTTON */}
          <div className="edit-last-ball-container">
            <button
              className="edit-last-ball-btn"
              onClick={() => {
                console.log('Edit Last Ball clicked');
                setShowEditBallModal(true);
              }}
              disabled={matchData?.status !== 'live' || !matchData?.recentBalls || matchData?.recentBalls.length === 0}
            >
              ✏️ Edit Last Ball
            </button>
          </div>
        </div>
      ) : (
        <div className="loading">
          <p>⏳ Waiting for match data...</p>
          <p className="hint">Make sure the match exists and is live</p>
        </div>
      )}

      {/* EDIT LAST BALL MODAL */}
      {showEditBallModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>✏️ Edit Last Ball</h3>
            <p>Select new outcome for the last ball:</p>
            <div className="edit-ball-options">
              {ballOutcomes.map((outcome, idx) => (
                <button
                  key={idx}
                  className={`edit-ball-btn ${outcome.color}`}
                  onClick={() => handleEditLastBall(outcome.value)}
                >
                  {outcome.label}
                </button>
              ))}
            </div>
            <button className="modal-cancel-btn" onClick={() => setShowEditBallModal(false)}>Cancel</button>
          </div>
        </div>
      )}

      {/* ADVANCED CONTROLS */}
      <div className="moderate-advanced-controls">
        <h3 className="moderate-controls-title">🎮 Advanced Match Controls</h3>
        <div className="moderate-controls-grid">
          <button className="moderate-control-btn moderate-timeout-btn" onClick={() => setShowTimeoutModal(true)} disabled={matchData?.status !== 'live' || matchStatus?.oversRemaining > 16}>
            ⏸️ Strategic Timeout
          </button>
          <button className="moderate-control-btn moderate-injury-btn" onClick={() => setShowInjuryModal(true)} disabled={matchData?.status !== 'live'}>
            🏥 Player Injury
          </button>
        </div>
      </div>

      {/* TIMEOUT MODAL */}
      {showTimeoutModal && (
        <div className="moderate-modal">
          <div className="moderate-modal-content">
            <h3 className="moderate-modal-title">⏸️ Strategic Timeout</h3>
            <p className="moderate-modal-text">Which team is taking the timeout?</p>
            <div className="moderate-modal-buttons">
              <button className="moderate-team-btn" onClick={() => { setTimeoutTeam(matchData?.spnnation1 || matchData?.teamA); handleStrategicTimeout(); }}>{matchData?.spnnation1 || matchData?.teamA}</button>
              <button className="moderate-team-btn" onClick={() => { setTimeoutTeam(matchData?.spnnation2 || matchData?.teamB); handleStrategicTimeout(); }}>{matchData?.spnnation2 || matchData?.teamB}</button>
              <button className="moderate-cancel-btn" onClick={() => setShowTimeoutModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* INJURY MODAL */}
      {showInjuryModal && (
        <div className="moderate-modal">
          <div className="moderate-modal-content">
            <h3 className="moderate-modal-title">🏥 Player Injury</h3>
            <input type="text" placeholder="Player Name" value={injuryData?.player || ''} onChange={(e) => setInjuryData({...injuryData, player: e.target.value})} className="moderate-modal-input" />
            <select value={injuryData?.team || 'A'} onChange={(e) => setInjuryData({...injuryData, team: e.target.value})} className="moderate-modal-select">
              <option value="A">Team A</option>
              <option value="B">Team B</option>
            </select>
            <select value={injuryData?.type || 'minor'} onChange={(e) => setInjuryData({...injuryData, type: e.target.value})} className="moderate-modal-select">
              <option value="minor">Minor (10 min)</option>
              <option value="moderate">Moderate (20 min)</option>
              <option value="severe">Severe (45 min)</option>
              <option value="concussion">Concussion (60 min)</option>
            </select>
            <div className="moderate-modal-buttons">
              <button className="moderate-confirm-btn" onClick={handlePlayerInjury}>Confirm Injury</button>
              <button className="moderate-cancel-btn" onClick={() => setShowInjuryModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {inningBreakInfo && (
        <div className="inning-break-control">
          <div className="break-info"><span>⏸️ Inning Break in Progress</span><span>Target: {inningBreakInfo.target} runs</span></div>
          <button className="force-start-btn" onClick={() => { if (socket && eventId) { socket.emit('force_start_second_innings', eventId); addNotification('Force starting second innings...', 'info'); } }}>🚀 Force Start Second Innings</button>
        </div>
      )}

      {matchData && matchData.status !== 'live' && matchData.status !== 'completed' && (
        <div className="start-match-control">
          <button className="start-match-btn" onClick={() => {
  if (socket && eventId) {
    socket.emit('start_match', { eventId, battingFirst });
    addNotification(`Starting match with ${battingFirst === 'teamA' ? matchData.teamA : matchData.teamB} batting first`, 'info');
  }
}}>
  🏏 Start Match
</button>
        </div>
      )}

      {matchData && matchData.status === 'break' && (
        <div className="start-match-control">
          <button className="resume-match-btn" onClick={() => { if (socket && eventId) { socket.emit('force_start_second_innings', eventId); addNotification('Starting second innings...', 'info'); } }}>🏏 Start Second Innings (Target: {matchData.target} runs)</button>
        </div>
      )}

{matchData && matchData.status === 'upcoming' && (
  <div className="batting-first-selector">
    <label>Which team bats first?</label>
    <div className="batting-options">
      <button
        className={`batting-option ${battingFirst === 'teamA' ? 'selected' : ''}`}
        onClick={() => setBattingFirst('teamA')}
      >
        {matchData.teamA || 'Team A'}
      </button>
      <button
        className={`batting-option ${battingFirst === 'teamB' ? 'selected' : ''}`}
        onClick={() => setBattingFirst('teamB')}
      >
        {matchData.teamB || 'Team B'}
      </button>
    </div>
  </div>
)}

      {sessionOdds.length > 0 && (
        <div className="odds-section">
          <h3>🎯 Session Odds (Over by Over)</h3>
          <div className="session-odds-grid">
            {sessionOdds.map((session, idx) => {
              const statusText = getStatusText(session.GameStatus, session.Active);
              const statusClass = getStatusClass(session.GameStatus, session.Active);
              const isSuspended = statusText === 'SUSPENDED';
              const overMatch = session.RunnerName.match(/(\d+)\s+over/);
              const overNumber = overMatch ? overMatch[1] : '?';
              const teamName = session.RunnerName.split(' over ')[1] || session.RunnerName;
              return (
                <div key={session.marketId} className={`session-card ${isSuspended ? 'suspended' : ''}`}>
                  <div className="session-header">
                    <span className="over-number">Over {overNumber}</span>
                    <span className="team-name">{teamName}</span>
                    <div className={`status-badge ${statusClass}`}>{statusText}</div>
                  </div>
                  <div className="session-odds-container">
                    <div className="odds-row"><span className="odds-label">BACK</span><span className="odds-value back">{session.BackPrice1 ? session.BackPrice1.toFixed(0) : '0'}</span></div>
                    <div className="odds-row"><span className="odds-label">LAY</span><span className="odds-value lay">{session.LayPrice1 ? session.LayPrice1.toFixed(0) : '0'}</span></div>
                  </div>
                  {session.Remark && <div className="session-remark">{session.Remark}</div>}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ScoreController;